import React from 'react';
import {render} from 'react-dom';

import {ArticleBottomNav} from '../../website-ui/modules/article-bottom-nav';
import {articleBottomNavMemoryRepository} from '../../website-ui/repositories/article-bottom-nav-memory-repository';

const initArticleCoverImageObserver = ($coverImage, articleId, isMobile) => {
  if (!isMobile || !$coverImage) {
    return;
  }

  const coverImageObserver = new IntersectionObserver(entries => {
    const isVisibleBottomNav = articleBottomNavMemoryRepository.get()?.[articleId]?.isVisible;
    const viewPortHeight = window.innerHeight;

    if (!entries[0].isIntersecting && !isVisibleBottomNav && entries[0].boundingClientRect.top < 0) {
      articleBottomNavMemoryRepository.set(articleId, true);
    }

    if (entries[0].isIntersecting && !isVisibleBottomNav) {
      articleBottomNavMemoryRepository.set(articleId, true);
      return;
    }

    if (!entries[0].isIntersecting && isVisibleBottomNav && entries[0].boundingClientRect.bottom > viewPortHeight) {
      articleBottomNavMemoryRepository.set(articleId, false);
    }
  }, {threshold: 1});

  coverImageObserver.observe($coverImage);
};

const manageArticleWidgetClasses = ($wrapper, isMobile) => {
  if (isMobile) {
    return;
  }

  const isHeaderExtended = Boolean(document.querySelector('.js-header-nav-container'));

  if (isHeaderExtended) {
    $wrapper.classList.add('extended');
  }

};

const initArticleBottomNav = ($wrapper, articleId, isMobile, $coverImage) => {
  if (!$wrapper) {
    return;
  }

  if (isMobile) {
    articleBottomNavMemoryRepository.set(articleId, false);
  }

  articleBottomNavMemoryRepository.subscribe((_, articles) => {
    if (articles?.[articleId].isVisible) {
      $wrapper.classList.add('sticky');
    } else {
      $wrapper.classList.remove('sticky');
    }
  });

  manageArticleWidgetClasses($wrapper, isMobile);
  initArticleCoverImageObserver($coverImage, articleId, isMobile);

  if ($wrapper && articleId) {
    render(
      <ArticleBottomNav articleId={articleId} />,
      $wrapper
    );
  }
};

export {initArticleBottomNav};
